import meetingImage from "./meetingImage";
export default meetingImage;


// WEBPACK FOOTER //
// /src/call/meeting/meetingImage/index.js